import { render, staticRenderFns } from "./BatchRemoveButton.vue?vue&type=template&id=f5bca5c8"
import script from "./BatchRemoveButton.vue?vue&type=script&lang=js"
export * from "./BatchRemoveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports